import { useMemo } from 'react';
import { DatePickerDate, DatePickerUtils } from '../types';

export const useWeeksInMonth = (utils: DatePickerUtils, date: DatePickerDate) => {
	return useMemo(() => {
		return date ? utils.getWeekArray(date).length : 4;
	}, [utils, date]);
};
